// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"T3-z","colorTextValue":"U3-z","swatches":"V3-z","collapseLink":"W3-z","isCollapsed":"X3-z","dropdown":"Y3-z","disabled":"Z3-z"};